import { InboxOutlined } from '@ant-design/icons';

type Props = {
    buttonText?: string;
};

const UploadFileButton = ({ buttonText = 'Click or drag file to this area to upload' }: Props) => {
    return (
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', justifyContent: 'center' }}>
            <InboxOutlined style={{ fontSize: 24, color: 'var(--brand-6)' }} />
            {buttonText}
        </div>
    );
};

export default UploadFileButton;
